import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import { database } from '@/plugins/firebase';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import { callFn } from '@/utils/functionsClient';
import { logActivity } from '@/services/ActivityLogService';
import Snackbar from '@/components/Snackbar.vue';
const SECTIONS = ['company', 'eet', 'terminal', 'season'];
let SchoolSettings = class SchoolSettings extends Vue {
    rules = VALIDATION_RULES;
    saving = '';
    /** The forms stay off screen until the documents are in, or a quick edit would be overwritten by the load. */
    ready = false;
    company = { name: '', ico: '', dic: '', address: '', footer: '' };
    eet = {
        enabled: false,
        environment: 'playground',
        eic: '',
        idJednotky: '',
        idPokl: '',
        url: '',
    };
    terminal = { deviceId: '', cardReady: false, printerReady: false };
    season = { year: '' };
    /** The stored season, which the picker cannot offer once it is in the past. */
    running = '';
    /** Loaded state, so the activity log entry can show what the value was before. */
    previous = { company: {}, eet: {}, terminal: {}, season: {} };
    environments = [
        { text: 'Playground', value: 'playground' },
        { text: 'Produkce', value: 'production' },
    ];
    /** Only forwards: an older season holds work documents under random ids. */
    get years() {
        const current = new Date().getFullYear();
        return [String(current), String(current + 1)];
    }
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    get heartbeatTitle() {
        const heartbeat = this.terminal.heartbeatAt;
        return heartbeat ? moment(heartbeat.toDate()).format('DD.MM.YYYY HH:mm') : 'nikdy';
    }
    optionalIco = value => !value || VALIDATION_RULES.ICO(value);
    async mounted() {
        const [company, eet, terminal, season] = await Promise.all(SECTIONS.map(section => database.collection('config').doc(section).get()));
        this.company = { ...this.company, ...company.data() };
        this.eet = { ...this.eet, ...eet.data() };
        this.terminal = { ...this.terminal, ...terminal.data() };
        this.season = { ...this.season, ...season.data() };
        this.running = this.season.year;
        this.previous = {
            company: company.data() || {},
            eet: eet.data() || {},
            terminal: terminal.data() || {},
            season: season.data() || {},
        };
        this.ready = true;
    }
    values(section) {
        if (section === 'company')
            return { ...this.company };
        if (section === 'eet')
            return { ...this.eet };
        if (section === 'season')
            return { ...this.season };
        return { deviceId: this.terminal.deviceId };
    }
    /** The switch hides a whole season from every screen, so it is confirmed. */
    confirmSeason() {
        return ConfirmDialog.open('Změna sezóny', `Změna sezóny na ${this.season.year} přepne rozvrhy, platby a účtenky na nová`
            + ' data. Stávající sezóna zůstane zachována, ale přestane být vidět. Pokračovat?');
    }
    async save(section) {
        const form = this.$refs[`${section}Form`];
        if (!form.validate())
            return;
        if (section === 'season' && !await this.confirmSeason())
            return;
        const values = this.values(section);
        this.saving = section;
        try {
            await callFn('saveConfig', { section, values });
            logActivity('UPDATE', 'config', section, this.previous[section], values);
            this.previous[section] = values;
            Snackbar.success('Nastavení uloženo');
        }
        catch (e) {
            Snackbar.error(e.message || 'Nastavení se nepodařilo uložit');
        }
        finally {
            this.saving = '';
        }
    }
};
SchoolSettings = __decorate([
    Component
], SchoolSettings);
export default SchoolSettings;
